export default {
    methods: {
        /**
         * @desc 获取格式化时间
         * @param timestamp:string 时间戳
         * @param format:string 格式
         */
        mixinGetUtcTime(timestamp, format = 'dot') {
            let d = new Date(timestamp),
                charDate;
            if (format == 'tomorrow') d.setDate(d.getDate() + 1);
            //根据date对象获取详细时间
            let year = parseInt(d.getUTCFullYear()),
                month = parseInt(d.getUTCMonth() + 1),
                dates = parseInt(d.getUTCDate()),
                hours = parseInt(d.getUTCHours()),
                minutes = parseInt(d.getUTCMinutes()),
                week = parseInt(d.getUTCDay());
            //小于10的数字前面加0
            if (month < 10) month = `0${month}`;
            if (dates < 10) dates = `0${dates}`;
            if (hours < 10) hours = `0${hours}`;
            if (minutes < 10) minutes = `0${minutes}`;
            //输入需要的时间格式

            //以"."为分隔符，默认此项 2016.9.21 12:00
            if (format == 'dot') charDate = `${year}-${month}-${dates}`;
            return charDate;
        },
        /**
         * @desc 获取时间
         * @param type:string 获取时间的类型
         * @param num:number 乘法因子
         */
        mixinGetDate(type = 'today', num = 1) {
            let date = '';
            switch (type) {
                case 'today':
                    date = this.mixinGetUtcTime(new Date().getTime());
                    break;
                case 'day':
                    date = this.mixinGetUtcTime(new Date().getTime() + 3600 * 1000 * 24 * num);
                    break;
                case 'yesterday':
                    date = this.mixinGetUtcTime(new Date().getTime() - 3600 * 1000 * 24 * num);
                    break;
                case 'week':
                    date = this.mixinGetUtcTime(new Date().getTime() - 3600 * 1000 * 24 * 7 * num);
                    break;
                case 'month':
                    date = this.mixinGetUtcTime(new Date().getTime() - 3600 * 1000 * 24 * 30 * num);
                    break;
                case 'year':
                    date = this.mixinGetUtcTime(new Date().getTime() + 3600 * 1000 * 24 * 365 * num);
                    break;
                default:
            }
            return date;
        },
        /**
         * @desc 限制input只能输入数字
         * @param e:obj event对象
         * @param bit:number 限制输入的位数
         * @param min:number 最小值
         * @param max:number 最大值
         * @return string 格式化后的数字字符串
         */
        mixinRegNum(e, bit, min = false, max = false) {
            let value = e.target.value;
            switch (bit) {
                case 0:
                    value = value.replace(/[^\d]/g, '');
                    break;
                case 2:
                    value = value.replace(/[^\d.]/g, ''); //清除"数字"和"."以外的字符
                    value = value.replace(/^\./g, ''); //验证第一个字符是数字
                    value = value.replace(/\.{2,}/g, '.'); //只保留第一个, 清除多余的
                    value = value
                        .replace('.', '$#$')
                        .replace(/\./g, '')
                        .replace('$#$', '.');
                    value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
                    if (value.match(/^0+[0-9]/)) value = value.substring(value.match(/^0+[0-9]/)[0].length - 1);
                //不限位数
                case -1:
                    value = value.replace(/[^\d.]/g, ''); //清除"数字"和"."以外的字符
                default:
                    break;
            }
            if ((min || min === 0) && value < min) value = min;
            if ((max || max === 0) && value > max) value = max;
            e.target.value = value;
            return value;
        },
        /**
         * @desc 深度处理对象复制
         * @param {Object} obj - 验证成功回调函数
         */
        deepClone(obj) {
            let _obj = JSON.stringify(obj);
            let objClone = JSON.parse(_obj);
            return objClone;
        },
        /**
         * @desc 获取url上参数
         * @param url:string url地址
         * @return object url参数的json对象
         */
        mixinGetQueryObject(url = window.location.href) {
            let search = url.substring(url.lastIndexOf('?') + 1),
                obj = {},
                reg = /([^&=]+)=([^&=]*)/g;
            search.replace(reg, (rs, $1, $2) => {
                let name = decodeURIComponent($1);
                let val = decodeURIComponent($2);
                val = String(val);
                obj[name] = val;
                return rs;
            });
            return obj;
        },
        /**
         * @desc 验证url
         * @param {String} url:验证的url
         * @return {Boolean}
         */
        mixinUrlReg(url) {
            return /(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(url);
        },
        /**
         * @desc 添加千分位
         * @param n:number 要添加千分位的数字
         * @return string 添加千分位后的字符串
         */
        mixinComdify(n) {
            if (typeof n === 'undefined') n = 0;
            let re = /\d{1,3}(?=(\d{3})+$)/g,
                n1 = n.toString().replace(/^(\d+)((\.\d+)?)$/, (s, s1, s2) => s1.replace(re, '$&,') + s2);
            return n1;
        },
        /**
         * @desc 验证图片尺寸
         * @param {Array} files - 图片文件列表
         * @param {Array} sizeList - 可以上传的图片尺寸列表
         * @param {Function} callback - 验证成功回调函数
         */
        verifyImgSize(files, sizeList, callback) {
            let url = window.URL || window.webkitURL;
            let count = 0;
            const arr = [];
            files.forEach((file, index) => {
                let img = new Image();
                img.src = url.createObjectURL(file);
                img.onload = () => {
                    //检查是否符合尺寸
                    const bool = Object.entries(sizeList).some(item => {
                        const bool = item[1] == `${img.width}x${img.height}`;
                        if (bool) arr[index] = item[0];
                        return bool;
                    });
                    // 不符合
                    if (!bool) arr[index] = false;
                    count++;
                    if (count == files.length) {
                        const sizeList = arr.every(item => item) ? arr : false;
                        if (sizeList) callback(sizeList);
                        else this.$Message.error({ content: '请上传正确尺寸的图片', duration: 2 });
                    }
                };
            });
        },
        /**
         * @desc 弹窗预览图片
         * @param {String} url 预览的图片地址
         * @param {String} size 宽x高
         */
        previewImg(url, size) {
            const width = ~~size.split('x')[0];
            this.$Modal.info({
                title: size,
                render: h =>
                    h('img', {
                        attrs: { src: url },
                        style: { width: `${width}px`, margin: '0 auto', marginTop: '20px' },
                    }),
                width: width + 40 > 418 ? width + 40 : 418,
                okText: '关闭',
            });
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/index.js